<template>
  <UserProfileButton @click="openDialog" />
  <BaseDialog :is-open="isOpen" type="basic" @close="closeDialog">
    <div class="text-on-surface flex h-full w-full flex-col items-center gap-2 pt-8 text-center">
      <h1 class="text-title-large">
        {{ organizationStore.currentOrganization.name }}
      </h1>
      <BaseShapeMask shape="12-sided-cookie" animation="spin" animation-duration="20s" class="p-1">
        <BaseMemberAvatar size="96" :member="user" />
      </BaseShapeMask>
      <p class="text-title-large">{{ `${$t('app.hello')} ${user.firstName}` }}!</p>
      <p class="text-label-medium mb-4">{{ user.email }}</p>
      <OrganizationSwitcher @close-dialog="closeDialog" />
      <div
        class="border-outline-variant mt-1 flex w-full flex-row flex-wrap justify-around py-2 text-xs"
      >
        <a href="https://menon.group/privacy-policy" target="_blank" rel="noreferrer">
          <BaseTextButton color="text" class="text-on-surface-variant! px-2!" size="XS">
            {{ $t('app.privacyPolicy') }}
          </BaseTextButton>
        </a>
        <a href="https://menon.group/terms-and-conditions" target="_blank" rel="noreferrer">
          <BaseTextButton color="text" class="text-on-surface-variant! px-2!" size="XS">
            {{ $t('app.termsAndConditions') }}
          </BaseTextButton>
        </a>
        <RouterLink v-if="user.specialTerms" :to="{ name: 'special-terms' }">
          <BaseTextButton color="text" class="text-on-surface-variant! px-2!" size="XS">
            {{ $t('app.specialTerms') }}
          </BaseTextButton></RouterLink
        >
      </div>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import UserProfileButton from './UserProfileButton.vue'
  import OrganizationSwitcher from '@/modules/organization/components/OrganizationSwitcher.vue'
  import { useUserStore } from '../../../stores/user.store'
  import { useOrganizationStore } from '../../../stores/organization.store'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'

  const { isOpen, closeDialog, openDialog } = useDialog()

  const organizationStore = useOrganizationStore()

  const { user } = useUserStore()
</script>
